const BASE_URL = "/wayback/available";

/**
 * 
 * @param url url정보
 * @param year 연도
 * @returns 최종 아카이브 요청 url
 */
export const GET_URL_ARCHIVE_INFO = (url: string, year: number) =>
  `${BASE_URL}?url=${url}&timestamp=${year}0101`;
